import React from 'react';
import PropTypes from 'prop-types';
import CommentsInputPage from './commentsInputPage';
import PreviewPage from './previewPage';

const MainComment = props => {
  let thanksForCommenting;
  let commentByMonth;
  let commentByDate;
  let isLeader;

  const imageInputErrorCodes = [
    'upload-error-general',
    'image-filesize-too-large',
    'image-size-too-small',
    'image-type-invalid',
    'could-not-validate',
    'network-error',
  ];

  if (
    props.translations['thank-you-for-commenting'] &&
    props.comment.commentBy.month
  ) {
    thanksForCommenting = props.translations[
      'thank-you-for-commenting'
    ].replace('%{name}', props.comment.user.firstName);
    commentByMonth = `<span class='date'>${props.translations[
      props.comment.commentBy.month
    ].replace('%{day}', props.comment.commentBy.day)}</span>`;
    commentByDate = props.translations['submit-comment-by-date'].replace(
      '%{date}',
      commentByMonth,
    );
  }

  if (props.comment.href) {
    isLeader = props.comment.href.indexOf('/leader/comments') !== -1;
  }

  return (
    <main className="site-width comment">
      {props.previewToggle && (
        <PreviewPage
          translations={props.translations}
          commentByDate={commentByDate}
          color={props.comment.program.color}
          uploadedImages={props.uploadedImages}
          togglePreview={props.togglePreview}
          submitComment={props.submitComment}
          tempComment={props.tempComment}
          spinnerDisplay={props.spinnerDisplay}
          error={props.error}
          bannedWordError={props.bannedWordError}
          isLeader={isLeader}
        />
      )}

      {props.comment.comment &&
        !props.previewToggle && (
          <CommentsInputPage
            commentByDate={commentByDate}
            imageInputErrorCodes={imageInputErrorCodes}
            isLeader={isLeader}
            {...props}
          />
        )}

      {!props.previewToggle &&
        !props.comment.comment && <h3>{thanksForCommenting}</h3>}
    </main>
  );
};

MainComment.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    commentBy: PropTypes.shape({
      day: PropTypes.string,
      month: PropTypes.string,
    }),
    comment: PropTypes.shape({}),
    user: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    href: PropTypes.string,
    program: PropTypes.shape({
      color: PropTypes.string,
    }),
  }).isRequired,
  previewToggle: PropTypes.bool.isRequired,
  tempComment: PropTypes.shape({}),
  spinnerDisplay: PropTypes.bool,
  error: PropTypes.string,
  bannedWordError: PropTypes.string,
  modalOnDisplay: PropTypes.string,
  privacyPolicyLink: PropTypes.string,
  imageLoading: PropTypes.number,
  uploadedImages: PropTypes.array,
  getTranslations: PropTypes.func,
  updateLocale: PropTypes.func,
  getUserInfo: PropTypes.func,
  validateCommentForm: PropTypes.func,
  displayModal: PropTypes.func,
  togglePreview: PropTypes.func,
  uploadImage: PropTypes.func,
  submitComment: PropTypes.func,
  deleteUploadedPhoto: PropTypes.func,
  rotatePhoto: PropTypes.func,
  addTempUserComment: PropTypes.func,
  addTempUserName: PropTypes.func,
};

MainComment.defaultProps = {
  tempComment: {},
  spinnerDisplay: false,
  error: '',
  bannedWordError: '',
  modalOnDisplay: '',
  privacyPolicyLink: '',
  imageLoading: null,
  uploadedImages: [],
  getTranslations: () => {},
  updateLocale: () => {},
  getUserInfo: () => {},
  validateCommentForm: () => {},
  displayModal: () => {},
  togglePreview: () => {},
  uploadImage: () => {},
  submitComment: () => {},
  deleteUploadedPhoto: () => {},
  rotatePhoto: () => {},
  addTempUserComment: () => {},
  addTempUserName: () => {},
};

export default MainComment;
